/**
 * Variables for use theme wide
 * Defined in page head to be in scope for other scripts
 * abc
 */

if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.theme.options = {
  loadSlider: false
};

Shopify.theme.jsLoadScript = (source, callback) => {
  let script = document.createElement('script');
  const prior = document.getElementsByTagName('script')[0];
  script.async = 1;

  script.onload = script.onreadystatechange = function (_, isAbort) {
    if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
      script.onload = script.onreadystatechange = null;
      script = undefined;
      if (!isAbort) if (callback) callback();
    }
  };

  script.src = source;
  prior.parentNode.insertBefore(script, prior);
};
